<template>
  <div class="col-sm-6 col-lg-3 text-center p-4">
    <h6>
      {{ product.name }}
    </h6>
    <div class="mb-2 show-more">
      <a
        class="btn btn-xs btn-info"
        target="_blank"
        :id="`product-details-${index}`"
        :href="product.url"
        v-if="product.url"
      >
        {{ $t('phrase.show_details') }}
      </a>
    </div>

    <img
      :src="product.image_url"
      class="img-fluid img-product mb-1"
    />
    <div
      class="text-description text-muted small mb-3"
      v-if="!showDescription"
    >
      {{ product.description_truncated }}
      <button
        class="btn btn-xs btn-link font-italic"
        @click="showDescription = true"
        v-if="product.description_truncated !== product.description"
      >
        <i class="fa fa-chevron-down"></i>
        {{ $t('phrase.show_all').toLowerCase() }}
      </button>
    </div>
    <div
      class="text-description text-muted small mb-3"
      v-else
    >
      {{ product.description }}
      <button
        class="btn btn-xs btn-link font-italic"
        @click="showDescription = false"
      >
        <i class="fa fa-chevron-up"></i>
        {{ $t('phrase.show_less').toLowerCase() }}
      </button>
    </div>

    <strong><i class="fa fa-coins"></i> {{product.price}}</strong>
    <div class="mt-4 mb-3" v-if="showBuyButton">
      <button
        :id="`product-buy-${index}`"
        type="button"
        class="btn btn-outline-danger"
        @click="$emit('product-selected', product)"
        :disabled="!isBuyable"
      >
        <span v-if="isBuyable">{{ $t('phrase.buy_now') }}</span>
        <span v-else>{{ $t('phrase.insufficient_coins') }}</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Product',
  props: {
    id: {
      type: String,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    product: {
      type: Object,
      required: true,
    },
    isBuyable: {
      type: Boolean,
      default() {
        return false;
      },
    },
    showBuyButton: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },
  data() {
    return {
      showDescription: false,
    };
  },
};
</script>

<style>
.text-description {
  min-height: 100px;
}

.img-product {
  height: 100px;
  width: auto;
}

div.show-more {
  height: 25px;
}
</style>
